import { ActionTypes } from "../constants/actionTypes";

const initialState = {
  all: [],
  single: {},
};

export default function homebaseReducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case ActionTypes.HOMEBASES_FETCH:
      return {
        ...state,
        all: payload,
      };
    default:
      return state;
  }
}
